import React from 'react';

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";

const styles = theme => ({
  root: {
    overflowY: 'auto'
  },
  scroller: {
    flexShrink: '0'
  }
});

function NavigationTabs (props) {
  const {
    classes,
    match,
    history,
    location,
    staticContext,
    className = '',
    pages = {},
    onClick = () => {},
    ...other
  } = props;

  return (
    <Tabs orientation="vertical"
          className={classes.root + ' ' + className}
          classes={{
            scroller: classes.scroller
          }}
          value={location.pathname.replace (/\/$/, '')}
          {...other}>
      <Tab label="Home"
           value=""
           onClick={() => {onClick (); history.push ('/')}} />
      {Object.entries (pages).map (([path, {label}]) =>
        <Tab key={path}
             label={label}
             value={path}
             onClick={() => {onClick (); history.push (path)}} />
      )}
    </Tabs>
  );
}

export default withStyles (styles) (withRouter (NavigationTabs));
